import { useState, useCallback, useRef, useEffect } from "react";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";
// import { Button, message, Typography, Table, Input, Space } from 'antd';
import ContentBox from "../../../../../components/ContentBox/ContentBox";

// import AccessCodeColumnDefs from "./AccessCodeColumnDefs";
import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import { setFileRowData } from "../../utils/slice";
import React from "react";


import * as CareerColDef from "../../../Careers/components/Listing/importColumnDefs";
import * as CertificationColDef from "../../../Certifications/components/Listing/importColumnDefs";
import * as AcronymColDef from "../../../Acronyms/components/Listing/importColumnDefs";
import * as EducationTrainingColDef from "../../../EducationTraining/components/Listing/importColumnDefs";
import * as ExperienceColDef from "../../../Experience/components/Listing/importColumnDefs";
import * as CareerPathColDef from "../../../CareerPath/components/Listing/importColumnDefs";
import * as UserManagementColDef from "../../../UserManagement/components/Listing/importColumnDefs";
import * as InterestDiscoveryColDef from "../../../InterestDiscovery/components/Form/ImportColumnDefs";
import * as SkillPortraitColDef from "../../../SkillPortrait/components/Listing/importColumnDefs";


/**
 * Renders the Listing component for AccessCodeListing module.
 *
 * @return {JSX.Element} The rendered Listing component.
 */


const DetailListing: React.FC<any> = () => {
    const mainFileLog = useAppSelector((state: RootState) => state.importActivity.fileRowdata);
    const details = useAppSelector((state) => state.importActivity.details);
    const initialOption: any = useAppSelector((state: RootState) => state.auth.initialData);

    console.log(CareerColDef.default)
    const [statusData, setStatusData] = useState<any>(null);
    const [rowData, setRowData] = useState([]);
    useEffect(() => {
        setStatusData(undefined)
        let CustomRowData = mainFileLog.data
        if (details?.module == 'Users Management') {
            CustomRowData = mainFileLog.data.user;
        }
        else if (details?.module == 'Interest Assessment') {
            CustomRowData = mainFileLog.data;
        }
        setRowData(CustomRowData);
        return () => {
            setStatusData(null)
            setRowData([])
        }
    }, [])


    const ActionRenderer = (props: any) => {
        return (<></>);
    };


    if (details?.module == undefined) {
        return <>No data Found</>;
    }
    var colDefs: any = [];
    switch (details.module) {
        case 'Careers':
            colDefs = CareerColDef.default;
            break;
        case 'Certifications':
            colDefs = CertificationColDef.default;
            break;
        case 'Acronyms':
            colDefs = AcronymColDef.default;
            break;
        case 'Education Training':
            colDefs = EducationTrainingColDef.default;
            break;
        case 'Experience':
            colDefs = ExperienceColDef.default;
            break;
        case 'Career Path':
            colDefs = CareerPathColDef.default;
            break;
        case 'Users Management':
            colDefs = UserManagementColDef.default;
            break;
        case 'Interest Discovery':
            colDefs = mainFileLog.type == 1 ? InterestDiscoveryColDef.colDefsGeneral(initialOption) : InterestDiscoveryColDef.colDefsTier1(initialOption);
            break;
        case 'Skill Portrait':
            colDefs = SkillPortraitColDef.default;
            break;
        default:
            colDefs = [];
            break;
    }


    // console.log('rowData',rowData);

    return (
        <>
            <ContentBox>

                <AgGridWrapper
                    components={{
                        ActionRenderer,
                    }}
                    className="import-log-details-table"
                    columnDefs={colDefs}
                    rowData={rowData || []}
                    context={{ setStatusData }}
                    onGridReadyWithDispatch={setFileRowData}
                    paginationPageSize={10}
                    cacheBlockSize={10}

                />
            </ContentBox>



        </>
    );
};

export default DetailListing;
